import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class ConfirmationReturnTo extends Component {
	render() {
		return (
			<div className="text-center">
				<a
					onClick={this.props.handleAuthRedirectFail}
					className="pp_guest_btn"
				>{this.props.returnto}</a>
			</div>
		);
	}
}

export default ConfirmationReturnTo;

ConfirmationReturnTo.propTypes = {
	returnto: PropTypes.string,
	handleAuthRedirectFail: PropTypes.func
}
